import { Controller } from '@hotwired/stimulus';

// Swaps the Sundays column of the comparison table between recipes. Every
// recipe's panes stay in the DOM (hidden, never removed) so crawlers see them all.
export default class extends Controller {
  static targets = ['tab', 'pane'];

  select(event) {
    const { recipe } = event.currentTarget.dataset;

    this.tabTargets.forEach((tab) => {
      const selected = tab.dataset.recipe === recipe;
      tab.classList.toggle('selected', selected);
      tab.setAttribute('aria-pressed', selected);
    });

    this.paneTargets.forEach((pane) => {
      pane.classList.toggle('d-none', pane.dataset.recipe !== recipe);
    });
  }
}
